<template>
	<div class="vl">
		<div v-for="(vl_item,vl_index) in venus_lst" :key="'vl'+vl_index" class="vl_item" @click="selectCity(vl_index)" >
			<div class="vl_item_title" ref="targetElements">
				{{vl_item.name}}<img :class="[{'vl_item_title_img':is_open !=vl_index}]" src="../resource/vl_1.png" alt="" />
			</div>
			<div v-if="is_open==vl_index" class="vl_block" @click.stop="nohandle()">
				<div v-for="(vll_item,vll_index) in vl_item.list" :key="'vl'+vl_index+'vll'+vll_index" class="vl_block_item">
					<div class="vl_block_item_1">{{vll_item.venue_name}}</div>
					<div class="vl_block_item_2">{{vll_item.address}}</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	// import { Button, Dialog } from 'element-ui'
	
	import naviBack from '../components/navi_back.vue';
	// import {
	// 	datePrintStr
	// } from "../lib/utils.js"
	export default {
		components: {
			naviBack
		},
		data() {
			return {
				venus_lst:[],
				is_open:0
			}
		},
		mounted() {
			this.getVenusList()
		},
		methods: {
			sortCities(cities) {
			    // 定义需要排在前面的城市及其顺序
			    const priorityCities = ['北京市', '上海市', '广州市', '深圳市'];
			    
			    // 创建一个映射，为每个优先级城市分配一个排名值
			    const cityRank = {};
			    priorityCities.forEach((city, index) => {
			        cityRank[city] = index;
			    });
			    
			    // 返回排序后的城市数组
			    return cities.sort((a, b) => {
			        // 如果 a 是优先级城市，b 不是，则 a 排在前面
			        if (cityRank.hasOwnProperty(a) && !cityRank.hasOwnProperty(b)) {
			            return -1;
			        }
			        // 如果 b 是优先级城市，a 不是，则 b 排在前面
			        if (cityRank.hasOwnProperty(b) && !cityRank.hasOwnProperty(a)) {
			            return 1;
			        }
			        // 如果 a 和 b 都是优先级城市，则按照定义的顺序排列
			        if (cityRank.hasOwnProperty(a) && cityRank.hasOwnProperty(b)) {
			            return cityRank[a] - cityRank[b];
			        }
			        // 如果 a 和 b 都不是优先级城市，则保持原顺序或按其他规则排序
			        return 0; // 或者使用其他排序规则，如字母顺序：a.localeCompare(b);
			    });
			},
			getVenusList(){
				var $this = this
				var param = {}
				var qs = require('qs');
				let url = this.api.userApi.index_getVenueList
				this.axios.post(url, qs.stringify(param))
					.then((res) => {
						// console.log(res)
						// console.log(venus_lst);
						var cityb=[]
						res.data.map((item)=>{
							cityb.push(item.city)
						})
						cityb=Array.from(new Set(cityb))
						// console.log(cityb);
						
						var city=$this.sortCities(cityb)
						// console.log(city);
						// 
						// return
						var venus_lst=[]
						city.map((item)=>{
							var params={
								city:item,
								name:item.slice(0, -1),
								list:[]
							}
							venus_lst.push(params)
						})
						// console.log(venus_lst);
						
						// return
						venus_lst.map((item_1)=>{
							res.data.map((item_2)=>{
								if(item_1.city==item_2.city){
									item_1.list.push(item_2)
								}
							})
						})
						// console.log(venus_lst);
						
						$this.venus_lst=venus_lst
					}).catch((error) => {
						console.warn(error)
						$this.$toast(error.msg?error.msg:error.message?error.message:"获取用户信息失败");
					})
			},
			nohandle(){
				console.log('不做处理');
			},
			selectCity(e){
				var $this=this
				if(this.is_open==e){
					this.is_open=-1
				}else{
					this.is_open=e
					setTimeout(()=>{
						$this.scrollPage(e)
					},500)
					
				}
			},
			scrollPage(e){
				var index=e-1
				if(index<0){
					window.scrollTo({
					  top: 0,
					  behavior: 'smooth'
					});
				}else{
					const element = this.$refs.targetElements[index];
					// console.log(element.getBoundingClientRect());
					var element_height=element.getBoundingClientRect().height
					  if (element) {
					    const targetPosition = element.getBoundingClientRect().top+window.pageYOffset;//+element_height //+ window.pageYOffset;
					    window.scrollTo({
					      top: targetPosition,
					      behavior: 'smooth'
					    });
					  }
				}
					
			}
		}
	}
</script>
<style lang="less" scoped="scoped">
	@vm_base: 1/750*100vw;
	.vl{
		width: 100%;
		min-height: 100vh;
		overflow: hidden;
		overflow-y: auto;
		background-color: #FFF3E8;
		padding: 30*@vm_base 30*@vm_base 30*@vm_base 30*@vm_base;
		padding-bottom: calc(constant(safe-area-inset-bottom) / 2+ 30*@vm_base);
		padding-bottom: calc(env(safe-area-inset-bottom) / 2 + 30*@vm_base);
	}
	.vl_item{
		width: 100%;
		background: linear-gradient( 180deg, #FFE2C8 0%, rgba(255,226,200,0.5) 100%);
		border-radius: 16*@vm_base;
		margin-bottom: 30*@vm_base;
		padding: 30*@vm_base;
		&:last-child{
			margin-bottom: 0;
		}
	}
	.vl_item_title{
		width: 100%;
		
		display: flex;
		justify-content: center;
		align-items: center;
		font-weight: 600;
		font-size: 28*@vm_base;
		color: #7C4B24;
		img{
			width: 30*@vm_base;
			margin-left: 20*@vm_base;
		}
		.vl_item_title_img{
			transform: rotateX(180deg);
		}
	}
	.vl_block{
		width: 100%;
		margin-top: 20*@vm_base;
		padding: 10*@vm_base 30*@vm_base 10*@vm_base 30*@vm_base;
		background: rgba(255,255,255,0.7);
		border-radius: 16*@vm_base;
		.vl_block_item{
			width: 100%;
			padding: 20*@vm_base 0;
			border-top: 1*@vm_base solid rgba(124,75,36,0.5);
			&:first-child{
				border-top: none;
			}
			.vl_block_item_1{
				width: 100%;
				font-size: 26*@vm_base;
				color: #7C4B24;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
			}
			.vl_block_item_2{
				width: 100%;
				padding-left: 34*@vm_base;
				background-image: url(../resource/vl_2.png);
				background-size:auto 28*@vm_base;
				background-position: left top;
				background-repeat: no-repeat;
				font-size: 24*@vm_base;
				color: rgba(124,75,36,0.7);
				line-height: 1.2;
				margin-top: 14*@vm_base;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/views/venus_list.vue